import { render, staticRenderFns } from "./BlockSettings.vue?vue&type=template&id=39305d04&scoped=true"
import script from "./BlockSettings.vue?vue&type=script&lang=ts"
export * from "./BlockSettings.vue?vue&type=script&lang=ts"
import style0 from "./BlockSettings.vue?vue&type=style&index=0&id=39305d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39305d04",
  null
  
)

export default component.exports